import React, { useState, useEffect } from "react";
import { Badge } from "react-bootstrap";

const CurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(""); // State for current time

  useEffect(() => {
    // Function to get the current time
    const updateTime = () => {
      const updatedTime = new Date().toLocaleString("en-US", {
        timeZone: "UTC", // International format
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
      setCurrentTime(updatedTime);
    };

    // Initialize time on mount
    updateTime();

    // Update time every second
    const timer = setInterval(updateTime, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(timer);
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <Badge
      className="d-inline-flex align-items-center badge text-muted pt-0 pb-3"
      style={{
        // backgroundColor: "white",
        fontSize: "14px",
        color: "white",
      }}
    >
      <i
        className="mdi mdi-web-clock"
        style={{ fontSize: "20px", marginRight: "8px" }}
      />
      {currentTime || ""} {/* Show "Loading..." if currentTime is empty */}
    </Badge>
  );
};

export default CurrentTime;
